import { styled } from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const CartIcon = styled(FontAwesomeIcon)`
  font-size: 72px;
  color: #ccc;
`;
